import React from "react";
import Exhibition from "./Exhibition";
import { nanoid } from "nanoid";

// Fallback year label for entries that don't carry an explicit `year`
// field (e.g. soloExhibitions_Data.js has none) — pulls the first
// 4-digit number out of the date string. Used only by the "timeline"
// variant so consecutive same-year entries can share one label + rail.
function inferYear(item) {
  if (item.year) return item.year;
  const match = item.date && item.date.match(/\d{4}/);
  return match ? match[0] : "";
}

function groupByYear(exhibitions) {
  const groups = [];
  let current = null;
  exhibitions.forEach(item => {
    const y = inferYear(item);
    if (!current || y !== current.year) {
      current = { year: y, entries: [] };
      groups.push(current);
    }
    current.entries.push(item);
  });
  return groups;
}

// `variant="timeline"` renders the year-rail layout used on the bio
// page's Solo/Group Exhibitions lists. Omit it (the default) to keep
// the original stacked-and-centered layout — used as-is on the home
// page's Upcoming Exhibitions list.
function Exhibitions({ exhibitions, variant }) {
  if (variant === "timeline") {
    const groups = groupByYear(exhibitions);
    return (
      <div className='exhibitionTimeline'>
        {groups.map(group => (
          <div className='exTimelineGroup' key={nanoid()}>
            <div className='exTimelineYear'>{group.year}</div>
            <div className='exTimelineEntries'>
              {group.entries.map(theExhibition => (
                <Exhibition
                  variant='timeline'
                  exhibition={theExhibition.exhibition}
                  location={theExhibition.location}
                  date={theExhibition.date}
                  key={nanoid()}
                  link={theExhibition.link}
                  linkOut={theExhibition.linkOut}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className='exhibitionContainer'>
      {exhibitions.map(theExhibition => (
        <Exhibition
          year={theExhibition.year}
          exhibition={theExhibition.exhibition}
          location={theExhibition.location}
          date={theExhibition.date}
          key={nanoid()}
          theLink={theExhibition.theLink}
          link={theExhibition.link}
          linkOut={theExhibition.linkOut}
        />
      ))}
    </div>
  );
}

export default Exhibitions;
